"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAbi = void 0;
const makeAbi = (abi) => abi;
exports.makeAbi = makeAbi;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS1hYmkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWFrZS1hYmkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRU8sTUFBTSxPQUFPLEdBQUcsQ0FBc0IsR0FBTSxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUE7QUFBOUMsUUFBQSxPQUFPLFdBQXVDIn0=